import { DateTime } from "luxon";
import { toast } from "react-toastify";
import * as yup from "yup";

export const driver_age_range = [16, 99];

export function getSchema(t) {
  const schema = yup.object().shape({
    pick_up_point: yup.object().shape({
      pick_up_point_code: yup.array().of(yup.string().required()),
      pick_up_point_meta: yup.object().shape({
        label: yup.string().required(t("pleaseSelectAPickUpPoint")),
      }),
    }),
    drop_off_point: yup
      .mixed()
      .test(
        "requiredWhenDifferentDropOff",
        "Drop off point is required when differentDropOff is true",
        function (value) {
          const { differentDropOff } = this.parent;
          if (differentDropOff) {
            return yup.object().required("Please select a Drop-off point.").isValidSync(value);
          }
          return true;
        },
      ),
    driver_age: yup
      .number()
      .typeError(t("enterValidDriversAge"))
      .positive(t("enterValidDriversAge"))
      .integer(t("enterValidDriversAge"))
      .min(driver_age_range[0], `Driver's Age must be at least ${driver_age_range[0]} years old.`)
      .max(driver_age_range[1], `Driver's Age must be at most ${driver_age_range[1]} years old.`)
      .test("valid-driver-age", t("enterValidDriversAge"), function (value) {
        if (this.parent.driver_age !== undefined && Number.isNaN(value)) {
          return false;
        }
        return true;
      })
      .required("Driver's Age is required."),
    pick_up_date: yup.date().required("Pick up date is required."),
    drop_off_date: yup
      .date()
      .required("Drop off date is required.")
      .test(
        "dropOffLaterThanPickUp",
        "Drop off date must be later than pick up date.",
        function (value) {
          const pick_up_date = this.parent.pick_up_date;
          const isoPickUp = DateTime.fromJSDate(pick_up_date).toISO();
          const isoDropOff = DateTime.fromJSDate(value).toISO();

          if (!isoPickUp || !isoDropOff) {
            return false;
          }
          return isoDropOff > isoPickUp;
        },
      ),
    differentDropOff: yup.boolean().required(),
    driver_nationality: yup.string().required(t("nationalityIsRequired")),
  });
  return schema;
}

export async function validateCarRentalSearchForm(data, t) {
  return await getSchema(t)
    .validate(data, { abortEarly: false })
    .then(() => {
      return true;
    })
    .catch((error) => {
      if (error?.errors.length) {
        toast.warning(
          <ul>
            {error.errors.map((error: string, idx: number) => (
              <li key={`${idx}-${error}`}>{error}</li>
            ))}
          </ul>,
        );
      }
      return false;
    });
}
